<template>
  <div :class="componentClassName">
    <slot><img src="@/images/a-application-complete-sign.svg" /></slot>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'a-application-complete-sign',
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-application-complete-sign');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
